/**
 * @name nthMerge
 * @desc Merges 2 arrays by inserting elements from the second array into the
 * first array after the specificed number of items. Will insert all elements
 * from second array if first array is consumed.
 *
 * @example
 * // const arr = [1, 2, 3, 4, 5]
 * // const arr2 = [a, b, c]
 * // const result = nthMerge(arr, arr2, 2)
 * // -> [1, 2, a, 3, 4, b, 5, c]
 */
export default <T1, T2>(arr1: T1[], arr2: T2[], nth: number): (T1 | T2)[] => {
  if (!arr1.length && arr2.length) {
    return arr2
  }

  return arr1.reduce((result: (T1 | T2)[], item, index) => {
    result.push(item)

    if (isLast(arr1, index) && arr2.length) {
      return result.concat(arr2)
    }

    if (index % nth === nth - 1 && arr2.length) {
      // @ts-ignore this algorithm should never shift off `undefined`
      result.push(arr2.shift())
    }

    return result
  }, [])
}

const isLast = (arr: any[], n: number) => arr.length - 1 === n
